import Vue from 'vue'

import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css' // Re-uses images from ~leaflet package
import 'leaflet'
import 'leaflet-defaulticon-compatibility'
import crypto from 'crypto-js'
import 'croppie/croppie.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import firebase from 'firebase/app'
import AlertComp from '@/components/util/Alert'
import VueCurrencyFilter from 'vue-currency-filter'
import settings from '@/settings'

import '@/styles/index.scss'
import SvgFiller from 'vue-svg-filler'

import VueCroppie from 'vue-croppie'

import moment from 'moment'
import vueTruncate from 'vue-truncate-filter'
import { VueEditor } from 'vue2-editor'

moment.locale('pt-br')

Vue.config.productionTip = false

Vue.component('app-alert', AlertComp)
Vue.component('svg-filler', SvgFiller)
Vue.use(crypto)
Vue.use(vueTruncate)
Vue.use(VueCroppie)
Vue.component('VueEditor', VueEditor)
Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.filter('formatDate', (value, format) => {
  if (value) {
    return moment(String(value)).format(format)
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp(settings.firebaseConfig)
  },
  computed: {
    naologar () {
      return this.$store.getters.naologar
    }
  },
  mounted () {
    firebase.auth().onAuthStateChanged((user) => {
      if (this.naologar) {
        this.$store.dispatch('setNaologar', false)
      } else {
        this.$store.dispatch('userChanged', user)
      }
    })
  }
}).$mount('#app')
